<template>
  <section class="u-bg--white u-align--left top">
    <div class="col-lg-12">
      <div class="breadcrumb u-bg--white">
        <simple-link :text="'Accueil'" :href="'/'" class="u-color--blue"/>
        <span v-if="slug"> > </span> <a class="link-breadcrumb" v-if="slug" :href="'/recommandation/' + slug"> {{nameText}}</a>
        <span v-else>> {{nameText}}</span>
      </div>
      <h1 class="principal-title">
        {{titleText}}
      </h1>
    </div>
     <script v-html="jsonld" type="application/ld+json"></script>
  </section>
</template>

<script>

  import SimpleLink from "./Link/SimpleLink";
  export default {
    name: "Top",
    components: {SimpleLink},
    props: ['theme', 'titleText', 'nameText', 'slug'],
    data () {
      const jsonld = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Accueil",
          "item": window.location.origin
        }, {
          "@type": "ListItem",
          "position": 2,
          "name": this.titleText,
          "item": window.location.href,
        }]
      }
      return {
        jsonld,
      }
    },

    created() {
      document.title = this.titleText + " - Application des reco dermato, SFD";
    },
    watch: {
      "$route.params.slug": function() {
        document.title = this.titleText + " - Application des reco dermato, SFD";
      }
    },
  }
</script>

<style lang="scss">
  section.top {
    padding-top: rem(30px) !important;
    padding-bottom: 0 !important;
    border-top: 1px solid color(border);
    border-bottom: 1px solid color(border);

    .breadcrumb {
      display: flex;
      font-size: rem(13px);
      line-height: rem(16px);
      align-items: center;

      @media print {
        display: none;
      }

      .link {
        margin: 0 rem(5px) 0 0;
      }

      span, .link-breadcrumb {
        font-weight: 700;
        color: color(grey-dark);
      }

      .link-breadcrumb {
        text-decoration: underline;
        padding-left: rem(5px);
      }

      @include mq($until: MD) {
        font-size: rem(10px);
        line-height: rem(13px);
      }
    }

    .principal-title {
      font-size: rem(30px);
      line-height: rem(30px);
      margin: 0;
      padding: rem(40px) 0 rem(25px);
      position: relative;
      -webkit-print-color-adjust: exact;

      &::after {
        position: absolute;
        content: '';
        height: rem(5px);
        width: rem(50px);
        left: 0;
        bottom: rem(-3px);
      }

      @include mq($until: MD) {
        font-size: rem(20px);
        line-height: rem(24px);
        padding: rem(20px) 0 rem(15px);
      }
    }

    &.orange {
      .principal-title::after {
        background-color: color(orange);
      }
    }

    &.blue {
      .principal-title::after {
        background-color: color(blue);
      }
    }
  }
</style>